type Format = 'long' | 'short';

export default function formatPrice(price: number, format: Format = 'long') {
  if (format === 'short') {
    return `€ ${Math.round(price)}`;
  }

  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  });

  let formattedPrice = formatter.format(price);

  // de-DE formats the price like 123,00 €. Strip the €,
  // so we can place it before the price
  formattedPrice = formattedPrice.replace('€', '');

  // formattedPrice = formattedPrice.replace(',00', '');

  return `€ ${formattedPrice}`.trim();
}
